// Chakra imports
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import LanguageSelector from 'components/i18n/LanguageSelector';

function AuthIllustration(props) {
  const { children, illustrationBackground } = props;
  const background = useColorModeValue(
    'linear(to-br, #f8fbff, #eef4ff 35%, #e9f0ff)',
    'linear(to-br, #0f1835, #161f45 45%, #1d2a56)'
  );
  const panelBorder = useColorModeValue('rgba(255,255,255,0.9)', 'rgba(255,255,255,0.15)');

  return (
    <Box position="relative" minH="100dvh" bgGradient={background} overflow="hidden">
      <Flex position="absolute" top={{ base: 4, md: 8 }} right={{ base: 4, md: 8 }} zIndex={2}>
        <LanguageSelector size="sm" variant="solid" showLabel />
      </Flex>
      <Box
        position="absolute"
        top="-220px"
        right="-220px"
        w="560px"
        h="560px"
        borderRadius="full"
        bgGradient="radial(brand.300, transparent 68%)"
        opacity={0.35}
        pointerEvents="none"
      />
      <Box
        position="absolute"
        bottom="-260px"
        left="-180px"
        w="520px"
        h="520px"
        borderRadius="full"
        bgGradient="radial(blue.300, transparent 70%)"
        opacity={0.22}
        pointerEvents="none"
      />
      <Flex
        position="relative"
        minH="100dvh"
        w="100%"
        px={{ base: 4, sm: 6, md: 8 }}
        pt={{ base: 'calc(env(safe-area-inset-top) + 1rem)', md: 8 }}
        pb={{ base: 'calc(env(safe-area-inset-bottom) + 1rem)', md: 8 }}
        align="center"
        justify="center"
      >
        <Flex
          w="100%"
          maxW={{ base: '100%', sm: '560px', md: '640px', xl: '1000px', '2xl': '1200px' }}
          justify={{ base: 'center', xl: 'space-between' }}
          align="stretch"
          gap={{ xl: 6, '2xl': 12 }}
        >
          {/* Form Side */}
          <Box
            flex={1}
            w="100%"
            maxW={{ base: '100%', sm: '560px', md: '640px' }}
            mx="auto"
            zIndex={1}
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            {children}
          </Box>

          {/* Illustration Side */}
          <Box
            flex={1}
            display={{ base: 'none', xl: 'flex' }}
            w="100%"
            maxW={{ base: '100%', sm: '560px', md: '640px' }}
            mx="auto"
            opacity={0.95}
            pointerEvents="none"
          >
            <Flex
              position="relative"
              w="100%"
              h="100%"
              minH="500px"
              overflow="hidden"
              borderRadius={{ base: '22px', md: '28px' }}
              border="1px solid"
              borderColor={panelBorder}
              bg="#142B76" /* Matching blue tone from LogiLift illustration background */
              boxShadow="0 24px 70px rgba(11, 31, 77, 0.20)"
            >
              <Box
                position="absolute"
                inset={0}
                bgImage={`url(${illustrationBackground})`}
                bgSize="cover"
                bgPosition="center"
                bgRepeat="no-repeat"
              />
              <Box
                position="absolute"
                inset={0}
                bgGradient="linear(to-b, rgba(8,24,66,0.02), rgba(8,24,66,0.38))"
              />
            </Flex>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
